import { border, borderColor, borderRadius, borderWidth, padding } from "polished"
import { StandardButton } from "../atoms/buttons"

export const AvatarButton = ({ avatar, isSelected, onClick }) => {
    return (
        <StandardButton backgroundColor={"transparent"} style={{padding: "0", borderColor: "var(--border-color)",}} className={`avatar-button ${isSelected ? "selected-avatar-button" : ""}`} onClick={onClick} >
            <img
                style={{ height:"100%", width:"100%", objectFit:"cover",aspectRatio: "1 / 1"}}
                src={avatar.src}
                alt={avatar.alt}
                className={`avatar-image ${isSelected ? "selected-avatar" : ""}`}
                onClick={onClick}
            />
        </StandardButton>
    )


}

export const AvatarBackgroundButton = ({ avatar, isSelected, onClick }) => {
    const colors = avatar.colors;
    const leftColor = colors[0];
    const centerColor = colors[1];
    const rightColor = leftColor;

    const backgroundGradient = `radial-gradient(circle 20rem at 50% 50%, ${leftColor} 0%, ${centerColor} 50%, ${rightColor} 100%)`;

    return (
        <StandardButton
            backgroundColor="transparent"
            style={{
                overflow: "hidden",
                padding: 0,
                minHeight: "clamp(4rem, 10vw, 6rem)",
                maxHeight: "clamp(4rem, 10vw, 6rem)",
                minWidth: "clamp(4rem, 10vw, 6rem)",
                maxWidth: "clamp(4rem, 10vw, 6rem)",
                borderRadius: "calc(1.5rem * var(--br-scale))",
                borderColor: "var(--border-color)",
                background: backgroundGradient,
            }}
            className={`avatar-background-button ${isSelected ? "selected-avatar-button" : ""}`}
            onClick={onClick}
        >
            {avatar.src && (
                <img
                    style={{ height: "100%", width: "100%", objectFit: "cover" ,aspectRatio: "1 / 1"}}
                    src={avatar.src}
                    alt={avatar.alt}
                    className={`avatar-image ${isSelected ? "selected-avatar" : ""}`}
                    onClick={onClick}
                />
            )}
        </StandardButton>
    );
};

export const AvatarPositionButton = ({ position, isSelected, onClick }) => {
    return ( 
    <StandardButton size="large" style={{ borderColor: isSelected ? "var(--primary-600)" : "var(--border-color)", boxShadow: isSelected ? "0 4px 4px rgba(0, 0, 0, 25%)" : "none", borderWidth: isSelected ? "2px" : "", transform: isSelected ? "scale(1.05)" : "",padding: "clamp(0.5rem, 2vw, 1rem) clamp(1rem, 5vw, 2rem)"}} textColor="standard-text-color" backgroundColor="white" title={position.title} onClick={onClick} />
    )
}